import React from 'react';
import {
  Placeholder,
  RouteData,
  ComponentRendering,
  withSitecoreContext,
} from '@sitecore-jss/sitecore-jss-react';
import { Grid, Container } from '@mui/material';

type RenderingProps = {
  rendering: RouteData | ComponentRendering;
  sitecoreContext: any;
};

const OneColumn = ({ rendering, sitecoreContext }: RenderingProps, route: RouteData) => {
  return (
    <>
      {!!sitecoreContext.route.fields['Page Body Title']?.value ? (
        <h1>{sitecoreContext.route.fields['Page Body Title']?.value}</h1>
      ) : (
        ''
      )}
      <Container maxWidth={false} disableGutters>
        <Grid container direction="row">
          <Grid item xs={12}>
            <Placeholder name="page_top_section" rendering={rendering} />
          </Grid>
        </Grid>
        <Grid container direction="row" alignItems="stretch">
          <Grid item xs={12} className="one-column-sublayout">
            <Placeholder name="page_content" rendering={rendering} />
          </Grid>
        </Grid>
        <Grid container direction="row">
          <Grid item xs={12}>
            <Placeholder name="page_section" rendering={rendering} />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default withSitecoreContext()(OneColumn);
